import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_missions = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/missions`,
        method: "GET"
    })
}

export const fetch_missions_by_id = async (mission_id) => {
    if (!mission_id) return { error: "No mission id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/id/${mission_id}`,
        method: "GET"
    })
}

export const create_new_mission = async (body) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/missions`,
        method: "POST",
        body: JSON.stringify(body)
    })
}

export const update_mission = async (mission_id, body) => {
    if (!mission_id) return { error: "No mission id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/id/${mission_id}`,
        method: "PUT",
        body: JSON.stringify(body)
    })
}

export const delete_mission = async (mission_id) => {
    if (!mission_id) return { error: "No mission id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/id/${mission_id}`,
        method: "DELETE"
    })
}

export const fetch_mission_members_by_id = async (mission_id) => {
    if (!mission_id) return { error: "No mission id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/members/${mission_id}`,
        method: "GET"
    })
}

export const add_mission_member = async (body) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/members`,
        method: "POST",
        body: JSON.stringify(body)
    })
}

export const remove_mission_member = async (mission_id) => {
    if (!mission_id) return { error: "No mission id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/members/${mission_id}`,
        method: "DELETE"
    })
}

export const update_mission_member = async (mission_id, body) => {
    if (!mission_id) return { error: "No mission id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/members/${mission_id}`,
        method: "PUT",
        body: JSON.stringify(body)
    })
}

export const fetch_mission_prayer_list = async (mission_id) => {
    if (!mission_id) return { error: "No mission id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/prayer/${mission_id}`,
        method: "GET"
    })
}

export const upload_missions_csv = async (csv_text) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/missions/upload-csv`,
        method: "POST",
        body: JSON.stringify({ csv_text })
    })
}

